import { makeStyles } from "@material-ui/core/styles";

interface IInputProps {
  color: string;
  colorFocus: string;
  border?: number;
}

export const useStyles = makeStyles((props: IInputProps) => ({
  customTextField: {
    boxShadow: "none",
    width: "100%",
    margin: "10px 0px",
    "& .MuiFilledInput-root": {
      background: "white",
      border: (props: IInputProps) => `1px solid ${props.color}`,
      borderRadius: 5,
      color: (props: IInputProps) => props.color,
    },
    "& .MuiFilledInput-root.Mui-error": {
      background: "white",
      border: (props: IInputProps) => `1px solid red`,
      borderRadius: 5,
      color: (props: IInputProps) => props.color,
    },
    "& .MuiFilledInput-underline:before": {
      display: "none",
    },
    "& .MuiFilledInput-underline:after": {
      display: "none",
    },
    "& .MuiFilledInput-root.Mui-focused": {
      border: (props: IInputProps) => `2px solid ${props.colorFocus}`,
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: (props: IInputProps) => props.colorFocus,
      fontWeight: 700,
    },
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
    },
  },
  customInputDate: {
    boxShadow: "none",
    width: "100%",
    margin: "10px 0px",
    padding: "4px 5px",
    border: (props: IInputProps) => `${props.border}px solid ${props.color}`,
    borderRadius: 5,
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiFormLabel-root": {
      marginLeft: 5,
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: (props: IInputProps) => props.colorFocus,
      fontWeight: 700,
    },
    "& .MuiFormControl-root.Mui-focused": {
      border: (props: IInputProps) => `2px solid ${props.colorFocus}`,
    },
  },
}));
